<template>
  <v-chip @click.stop="goTo" color="grey lighten-3">
    <slot />
    <v-icon class="ml-1">mdi-arrow-right</v-icon>
  </v-chip>
</template>

<script>
export default {
  props: ['to'],
  methods: {
    goTo() {
      if (this.$route.path !== this.to) {
        this.$router.push(this.to)
      }
    }
  }
}
</script>